import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import img1 from "../../Assets/clients/c/client11.webp";
import img2 from "../../Assets/clients/c/client12.webp";
import img3 from "../../Assets/clients/c/client14.webp";
import img4 from "../../Assets/clients/c/client13.webp";
import img5 from "../../Assets/clients/c/client15.webp";
import img6 from "../../Assets/clients/c/client16.webp";
import img7 from "../../Assets/clients/c/client17.webp";
import img8 from "../../Assets/clients/c/client18.webp";
import img9 from "../../Assets/clients/c/client19.webp";
import img10 from "../../Assets/clients/c/client20.webp";

import img11 from "../../Assets/clients/c/client21.webp";
import img12 from "../../Assets/clients/c/client22.webp";
import img13 from "../../Assets/clients/c/client23.webp";
import img14 from "../../Assets/clients/c/client24.webp";
import img15 from "../../Assets/clients/c/client25.webp";
import img16 from "../../Assets/clients/c/client26.webp";
import img17 from "../../Assets/clients/c/client27.webp";
import img18 from "../../Assets/clients/c/client28.webp";
import img19 from "../../Assets/clients/c/client29.webp";
import img20 from "../../Assets/clients/c/client30.webp";
import img21 from "../../Assets/clients/c/client31.webp";

import Carousel from "react-bootstrap/Carousel";
import "../../App.css";

function CustomSlider() {
  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4 className="text-center text-danger mt-5">
              SOME OF OUR CLIENTS
            </h4>
          </Col>
        </Row>
      </Container>

      <Carousel
        variant="dark"
        className="pb-4 m-2"
        interval={1500}
        pause={false}
      >
        <Carousel.Item className="p-lg-4">
          <div className="text-center">
            <img
              src={img1}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img2}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img3}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img4}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img5}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
          </div>
        </Carousel.Item>
        <Carousel.Item className="p-lg-4">
          <div className="text-center">
            <img
              src={img7}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img8}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img9}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img10}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img6}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
          </div>
        </Carousel.Item>
        <Carousel.Item className="p-lg-4">
          <div className="text-center">
            <img
              src={img11}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img12}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img13}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img14}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img15}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
          </div>
        </Carousel.Item>
        <Carousel.Item className="p-lg-4">
          <div className="text-center">
            <img
              src={img16}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img17}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img18}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img19}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
            <img
              src={img20}
              style={{ width: "200px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
             <img
              src={img21}
              style={{ width: "120px" }}
              className="mx-auto px-2 pt-3"
              alt="client-img"
            />
          </div>
        </Carousel.Item>
      </Carousel>
    </>
  );
}

export default CustomSlider;
